import {
  compose,
  withPropsOnChange,
  withProps,
} from 'recompose'

import * as R from 'ramda'

import { toirStatusesTransport } from './toirStatusesTransport'
import { toirIssueTransport } from './toirIssueTransport'
import prepareToirIssueForWidget from './prepareToirIssueForWidget'


const withToirIssueOnView = compose(
  toirStatusesTransport,
  withProps(({ data: { esuz } }) => ({
    toirIssueId: esuz,
  })),
  toirIssueTransport,
  withPropsOnChange([`toirIssues`, `toirStatuses`], ({ toirIssues, setIssueLinkData, toirStatuses }) => {
    if (!R.isEmpty(toirIssues) && !R.isEmpty(toirStatuses)) {
      const tempIssue = R.head(prepareToirIssueForWidget(toirIssues, toirStatuses))
      setIssueLinkData(tempIssue)
    }
  }),
)


export default withToirIssueOnView
